import type { TrPageConfigInterface } from '@core/utils/TrPageConfig.interface'
import { useRouter } from '@/router/useRouter'

const Names = {
  fr: 'iframe',
  en: 'iframe'
}

const Config: TrPageConfigInterface = {
  name: Names.fr,
  path: `/${Names.fr}`,
  alias: `/${Names.en}`,
  component: () => import('@page/iframe/IFrameResults.vue'),
  beforeEnter: async (to, from, next) => {
    await useRouter().preloadSettingPage(to)
    next()
  }
}

export { Config }
